import { render, staticRenderFns } from "./DuoImages.vue?vue&type=template&id=55ca862d&scoped=true&"
import script from "./DuoImages.vue?vue&type=script&lang=js&"
export * from "./DuoImages.vue?vue&type=script&lang=js&"
import style0 from "./DuoImages.vue?vue&type=style&index=0&id=55ca862d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca862d",
  null
  
)

export default component.exports